import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { loadError } from '../error/error.action';

@Injectable()
export class ErrorEffects {
  constructor(private actions$: Actions) {}

  public loadError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadError),
        map((error) => {
          console.error(error);
        })
      ),
    { dispatch: false }
  );
}
